// Zod-free leaf module: plain enums only (RET1-2734). Keep this file free of
// imports so lean bundles can use these values without loading zod schemas.

export enum DateOption {
  BEFORE = "Before or on",
  AFTER = "After or on",
  BETWEEN = "Between",
}

export enum NumClaimsOption {
  LESS_THAN = "Less than",
  GREATER_THAN = "Greater than",
}

export enum NumReturnsOption {
  LESS_THAN = "Less than",
  GREATER_THAN = "Greater than",
}

export enum NumOrdersOption {
  LESS_THAN = "Less than",
  GREATER_THAN = "Greater than",
}

export enum ReturnRateOption {
  LESS_THAN = "Less than",
  GREATER_THAN = "Greater than",
}

export enum NumItemsBeingReturnedOption {
  LESS_THAN = "Less than",
  GREATER_THAN = "Greater than",
  EQUALS = "Equals",
}

export enum AdjustmentAmountOption {
  LESS_THAN = "Less than",
  GREATER_THAN = "Greater than",
  EQUALS = "Equals",
}

export enum NumItemsInReturnOption {
  LESS_THAN = "Less than",
  GREATER_THAN = "Greater than",
  EQUALS = "Equals",
}

export enum PaymentMethodOption {
  GIFT_CARD = "Gift Card",
  MANUAL = "Manual",
  OTHER = "Other",
}

export enum DiscountOptionModel {
  ORDER = "order",
  ITEM = "item",
}

export enum ItemDiscountMeasureOption {
  PERCENT = "percent",
  AMOUNT = "amount",
}

export enum LoyaltyEarnedMeasureOption {
  PERCENT = "percent",
  AMOUNT = "amount",
}

// value set {contains,exact} coincides with the unrelated url_matching_type DB enum //redontIgnore
export enum DiscountMatchType {
  EXACT = "exact",
  CONTAINS = "contains",
}

/**
 * How a `COMPENSATION_METHOD` condition compares the merchant's selected
 * methods against the methods that exist on the return.
 *
 * - `CONTAINS`: the return has at least one of the selected methods.
 * - `ALL`: the return has every selected method (it may also have others).
 */
export enum CompensationMethodMatchType {
  CONTAINS = "contains",
  ALL = "all",
}

/** How reason matches reduce across returned items: any/all/no item matches. */
export enum ReturnReasonMatchType {
  ANY = "any",
  ALL = "all",
  NONE = "none",
}

// value set {contains,exact} coincides with the unrelated url_matching_type DB enum //redontIgnore
export enum SubjectLineMatchType {
  EXACT = "exact",
  CONTAINS = "contains",
}

export enum ProductTagMatchType {
  ALL = "all",
  ANY = "any",
  NONE = "none",
}

/**
 * Which point in time a tag/metafield condition evaluates against. Absent means
 * the condition's legacy behavior (see each condition's evaluate case).
 */
export enum EvaluationTime {
  TIME_OF_ORDER = "time_of_order",
  TIME_OF_RETURN = "time_of_return",
}

export enum SkuMatchType {
  ALL = "all",
  ANY = "any",
  NONE = "none",
}

export enum AssignmentTypeOption {
  AI_AGENT_ASSIGNEE = "AI agent assigned",
  SUPPORT_AGENT_ASSIGNEE = "Support agent assigned",
  NO_ASSIGNEE = "No assignee",
}
